export function containsPendingRequest(text: string) {
  const searchString =
    "Request of type 'wallet_requestPermissions' already pending"
  const regex = new RegExp(searchString, 'i') // 'i' flag for case-insensitive search
  return regex.test(text)
}
